import addDays from "date-fns/addDays";
import type { EntityValidationRules } from "../services/validationService";
import { observable } from "mobx";
import type { ManualEntityValidator } from "@frui.ts/validation";
import { endOfCzechDay, startOfCzechDay } from "../utils/dateUtils";
import { subDays } from "date-fns";
import { startOfEDAZDistribution } from "config";

export default class VehicleChange {
  @observable
  oldCountryId: string;
  @observable
  oldLicensePlate: string;
  @observable
  newLicensePlate: string;
  @observable
  newCountryId: string;
  @observable
  officialRecordId: string;
  @observable
  submissionDate: Date = new Date();
}

export const VehicleChangeValidationRulesFactory: (
  manualValidation: ManualEntityValidator<VehicleChange>
) => EntityValidationRules<VehicleChange> = manualValidation => ({
  oldCountryId: {
    required: true,
  },
  oldLicensePlate: {
    required: true,
    isLicensePlate: true,
  },
  newCountryId: {
    required: true,
    manualValidation,
  },
  newLicensePlate: {
    required: true,
    isLicensePlate: true,
    manualValidation,
  },
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
  submissionDate: {
    required: true,
    isBefore: {
      before: startOfCzechDay(addDays(new Date(), 1)),
    },
    isAfter: {
      after: endOfCzechDay(subDays(startOfEDAZDistribution, 1)),
    },
  },
});
